// window.fixSizes = function () {
//   setTimeout(function () {
//     // if (window.innerHeight < window.innerWidth) {
//     //   jQuery(".fp-scroller").each(function () {
//     //     jQuery(this).find('.group').css('height', jQuery(this).height() + jQuery('.header-container').height())
//     //   })
//     // } else {
//     //   jQuery('.group').each(function () {
//     //     jQuery(this).removeAttr("style")
//     //   })
//     // }
//   }, 500)
// }

window.mobilecheck = function() {
  var check = false;
  // eslint-disable-next-line no-useless-escape
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// window.onresize = function () {
//   if (window.initialWidth == jQuery(window).height()) {
//     location.reload()
//   }
// }

export default {
  init () {
    // JavaScript to be fired on all pages
    jQuery(document).ready(function () {

      // jQuery('.cn').click(function(){
      //   alert(jQuery(this).attr('type'));
      //   var bar = document.getElementById('cookie-notice')
      //   bar.style.display = 'none'
      //   var now = new Date()
      //   var time = now.getTime()
      //   time += 3600 * 24 * 365 * 1000
      //   now.setTime(time)
      //   document.cookie =
      //   'cookie_notice=' + jQuery(this).attr('type') +
      //   '; expires=' + now.toUTCString() +
      //   '; path=/'
      // })

      // jQuery(function ($) {
      //     var counter = 0
      //     $.each(document.cookie.split(/; */), function () {
      //         var splitCookie = this.split('=')
      //         if (splitCookie[0] == 'cookie_notice') {
      //             counter++
      //             if (splitCookie[1] == '') {
      //                var cB = document.getElementById('cookie-notice')
      //                cB.style.opacity = '1'
      //             }
      //         }
      //     })
      //     if (counter < 1) {
      //         var cB = document.getElementById('cookie-notice')
      //         cB.style.opacity = '1'
      //     }
      // })

      var scrollableElements = '.nav';

      if(window.mobilecheck()) {
        if (jQuery(window).width() > jQuery(window).height()) {
          jQuery('.two-col-two').each(function () {
            if (jQuery(this).outerHeight() > jQuery(this).parent().find('.two-col-one').outerHeight()) {
              jQuery(this).parent().find('.two-col-one').css('height', jQuery(this).outerHeight())
            }
          })
        }
        scrollableElements = '.nav, .scrollable-content'
      }

      // window.initialWidth = jQuery(window).width()
      // window.initialHeight = jQuery(window).height()

      // var is_smooth = jQuery('.horizontal-timeline').html() !== undefined ? false : true
      var fullPageExisting = false

      var video_playing = null
      let sections = jQuery('.section')

      if (jQuery('#fullpage').html() !== undefined) {
        fullPageExisting = true
        jQuery('#fullpage').fullpage({
          autoScrolling: true,
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          navigation: true,
          navigationPosition: 'right',
          anchors: window.anchors,
          normalScrollElements: scrollableElements,
          scrollOverflow: true,
          // bigSectionsDestination: 'top',
          verticalCentered: false,
          afterLoad: function () {
            // window.fixSizes()
          },
          onLeave: function (origin, destination, direction) {

            // console.log(origin, destination, direction)

            // if (direction == 'down') {
            //   let target = sections[destination.index]
            //   let delay = 0.2
            //   let incDelay = 0.2
            //   jQuery(target).find('.is-animated').each(function () {
            //     delay = delay + incDelay
            //     jQuery(this).addClass('animated').css('animation-delay', delay + 's')
            //   })
            // }

            let target = sections[destination.index]
            let source = sections[origin.index]

            //Show/hide header on scroll
            if (direction === 'down') {

              // if(window.innerHeight < window.innerWidth) {
              //   jQuery(".fp-scroller").each(function () {
              //     jQuery(this).find('.flex-wrapper').css('height', jQuery(this).height())
              //   })
              // }

              // jQuery('.header-outer').addClass('nav-up')
              // jQuery('.two-col-one').each(function () {
              //   jQuery(this).parent().css('height', jQuery(this).parent().height())
              // })

            } else if (direction === 'up') {
              // jQuery('.header-outer').removeClass('nav-up')

              // Check for auto playing stuff
              if (target) {
                let id = jQuery(target).find('video').attr('id')
                if (id !== undefined) {
                  video_playing = document.getElementById(id)
                  if (jQuery(video_playing).attr('autoplay')) {
                    video_playing.play()
                  }
                } else if (video_playing !== null) {
                  if (jQuery(video_playing).attr('autoplay')) {
                    video_playing.pause()
                  }
                }
              }
            }

            if (jQuery(target).data('constructor')) {
              let cb = jQuery(target).data('constructor')
              if (window.hasOwnProperty(cb)) {
                window[cb]()
              }
            }
            if (jQuery(source).data('destructor')) {
              let cb = jQuery(source).data('destructor')
              if (window.hasOwnProperty(cb)) {
                window[cb]()
              }
            }

          },
        })
      }

      // Search and navigation toggle
      jQuery('.icon-search').click(function () {
        if (fullPageExisting) {
          $.fn.fullpage.setMouseWheelScrolling(false)
          $.fn.fullpage.setAllowScrolling(false)
        }

        //Show menu
        jQuery('.nav-toggle').addClass('show')

        //Hide menu items
        jQuery('.nav-container').hide()

        //Show search menu data
        jQuery('.nav-container-search').show()

        //Add animation to search box
        /* jQuery(this).next('.search-toggle').addClass('active') */

        //If window is mobile or tablet hide logo
        /* if ($(window).width() < 769) {
           jQuery('.logo').addClass('visibility-hidden')
        } */
      })

      var searchField = jQuery('.nav-container .search-field')

      var doSearch = function () {
        // console.log(searchField.val());
        // start loading indicator
        jQuery('.lds-spinner').addClass('visibility-visible')

        //hide search results on every search
        jQuery('.nav-search-results').hide()
        jQuery.get('/?s=' + searchField.val(), function (response) {
          // hide loading indicator
          jQuery('.lds-spinner').removeClass('visibility-visible')
          jQuery('.nav-search-results').show()
          jQuery('.nav-search-results').html(jQuery(response).find('#search-results-ajax').html())
        })
      }

      searchField.keyup(function (e) {
        //Enter
        if (e.which == 13) {
          e.stopPropagation()
          e.preventDefault()
          doSearch()
        }
      })

      searchField.on('input', function () {
        //hide results if search field is empty
        if (!searchField.val()) {
          jQuery('.search-results-wrapper').hide()
        }
      })

      jQuery('.search-submit').click(function (e) {
        e.stopPropagation()
        e.preventDefault()
        doSearch()
      })

      jQuery('.icon-menu').click(function () {
        if (fullPageExisting) {
          $.fn.fullpage.setMouseWheelScrolling(false)
          $.fn.fullpage.setAllowScrolling(false)
        }
        jQuery(this).next('.nav-toggle').addClass('show')
      })

      jQuery('.icon-close').click(function () {
        if (fullPageExisting) {
          $.fn.fullpage.setMouseWheelScrolling(true)
          $.fn.fullpage.setAllowScrolling(true)
        }
        jQuery('.nav-wrapper .nav-toggle').removeClass('show')
        //Hide search data
        jQuery('.nav-container-search').hide()

        //Show menu items
        jQuery('.nav-container').show()
      })

      //Main menu
      jQuery('.nav > li').each(function () {
        if (jQuery(this).hasClass('current_page_parent')) {
          jQuery(this).find('> .sub-menu').css({ 'display': 'block' })
        }
        if (jQuery(this).find('.sub-menu').length > 0) {
          if (jQuery(this).hasClass('current_page_parent')) {
            jQuery(this).children('a').after('<span class="menu-toggle-icon open"></span>')
          } else {
            jQuery(this).children('a').after('<span class="menu-toggle-icon"></span>')
          }
        }
      })
      // Sub menu
      jQuery('.nav > li > .sub-menu > li').each(function () {
        if (jQuery(this).hasClass('current_page_item')) {
          jQuery(this).find('.sub-menu').css({ 'display': 'block' })
        }
        if (jQuery(this).find('.sub-menu').length > 0) {
          if (jQuery(this).hasClass('current_page_item')) {
            jQuery(this).children('a').after('<span class="menu-toggle-icon-sub open"></span>')
          } else {
            jQuery(this).children('a').after('<span class="menu-toggle-icon-sub"></span>')
          }
        }
      })

      jQuery('.menu-toggle-icon').click(function () {
        let self = this
        jQuery('.nav > li > .menu-toggle-icon').each(function () {
          if (jQuery(this)[0] !== jQuery(self)[0]) {
            jQuery(this).next('.sub-menu').slideUp()
            jQuery(this).next('.sub-menu').find('.sub-menu').slideUp()
            jQuery(this).removeClass('open')
            jQuery(this).next('.sub-menu').find('.menu-toggle-icon-sub').removeClass('open')
          }
        })
        jQuery(this).next('.sub-menu').slideToggle()
        jQuery(this).toggleClass('open')
      })

      jQuery('.menu-toggle-icon-sub').click(function () {
        let self = this
        jQuery('.nav > li > .sub-menu > li > .menu-toggle-icon-sub').each(function () {
          if (jQuery(this)[0] !== jQuery(self)[0]) {
            jQuery(this).next('.sub-menu').slideUp()
            jQuery(this).removeClass('open')
          }
        })
        jQuery(this).next('.sub-menu').slideToggle()
        jQuery(this).toggleClass('open')
      })

      //Modal
      jQuery('.modal-toggle').on('click', function (e) {
        e.preventDefault()
        jQuery('.modal').toggleClass('is-visible')
      })

      // Last section whitespace
      // jQuery('.section:not(.section-footer):last').children('.fp-tableCell').css('clear', 'both');

    })
  },
  finalize () {
    // window.fixSizes()
    // JavaScript to be fired on all pages, after page specific JS is fired
    setInterval(function () {
      jQuery('.slideshow-autoplay').each(function () {
        var $active = jQuery('img.active', this)
        var $next = ($active.next('img').length > 0) ? $active.next('img') : jQuery(':first', this)
        $next.css('z-index', 2)//move the next image up the pile
        $active.fadeOut(1500, function () {//fade out the top image
          $active.css('z-index', 1).show().removeClass('active')//reset the z-index and unhide the image
          $next.css('z-index', 3).addClass('active')//make the next image the top one
        })
      })
    }, 3000)

  },
}
